module.exports = __webpack_public_path__ + "static/media/viewall.2c4eaeb2.svg";